export class GetValidMenuItemResponse {
  Successful: boolean = false;
  Message: string = '';
  Tag: string = '';
  ObjectTag: NavItemEntityResponse = new NavItemEntityResponse();
  TagType: string = '';
  ProcessToken: string = '';
}

export class NavItemEntityResponse {
  // public Successful: boolean = false;
  // public Message: string = "";

  public login_token: string = "";
  public email_id: string = "";
  public post_id: number = 0;
  public under_supervision_post_ref: number = 0;
  public role: number = 0;
  public role_name: string = "";
  public phone_nos: string = "";
  public user_display_name: string = "";
  // public ValidMenuItemIds2: string[] = [];
  // public LastSelectedChapterRef: number = 0;
  // public LastSelectedChapterName: string = "";
  public to_date: string = "";
  // public LastSelectedSubChapterRef: number = 0;
  // public LastSelectedSubChapterName: string = "";
  public login_user_id: number = 0;
  public first_login_completed: number = 0;
  // public ChapterRef: number = 0;
  // public SubChapterRef: number = 0;
  public short_name: string = "";
  public financial_year_responses: any[] = [];
  public months: number[] = [];
  public profile_pic_path: string = "";
  valid_web_menu_item_ids : NavItemEntityAuthority[] = [];
}
export class NavItemEntityAuthority {
  //Entity_Authority
  feature: string = '';
  feature_group: string = '';
  menu_id: string = ''; // EntityType
  can_add: boolean = false;
  can_view: boolean = false;
  can_edit: boolean = false;
  can_delete: boolean = false;
  can_export: boolean = false;
}